import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const icons = {
  CheckCircleIcon
};

const approvedcaseGadgetagent = {
  id: 'Approvalreq',
  type: 'group',
  children: [
    {
      id: 'Approvalreq',
      title: 'Intimation Approval',
      type: 'item',
      url: '/Intimation-Approval',
      icon: icons.CheckCircleIcon,
    }
  ]
};

export default approvedcaseGadgetagent;
